export function booleanToString(value: boolean): string {
  return value ? 'yes' : 'no';
}
